import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';
import { H1, H2 } from '../../components/UI/TextStyles';
import { Text, View, StyleSheet } from 'react-native';
import { isRowLayout } from '../../utilities/screen';
import { BERRY } from '../../settings/colors';
import { useHistory } from 'react-router-dom';
import { Button } from '../../components';

const styles = StyleSheet.create({
  step: {
    flex: isRowLayout ? 1 : undefined,
    marginRight: isRowLayout ? 40 : 0,
    marginBottom: isRowLayout ? 0 : 20,
  },
});

function HowItWorks() {
  const history = useHistory();
  return (
    <StaticPage>
      <H1 centered>So funktioniert Triff.</H1>
      <View
        style={{
          marginVertical: 40,
          maxWidth: 500,
          alignSelf: 'center',
          alignItems: 'center',
        }}
      >
        <Text style={{ fontSize: 'large', textAlign: 'center' }}>
          Triff ist die App für das echte Leben. Wir finden, wir sollten alle
          wieder mehr miteinander machen. Darum machen wir es einfach, mehr zu
          machen. Mit Freunden und neuen Bekanntschaften. Denn Begegnungen sind
          es, die das Leben ausmachen.
        </Text>
        <Button
          text={'Jetzt mitmachen'}
          action={() => history.push('/register')}
          style={{ marginTop: 20 }}
        />
      </View>
      <View style={{ flexDirection: isRowLayout ? 'row' : 'column' }}>
        <View style={styles.step}>
          <H2>1. Anbieten</H2>
          <Text>
            Bei Triff kannst du anbieten, was immer du möchtest. Ein
            Mittagstisch, eine Nordic-Walking-Gruppe oder ein Malkurs – du
            entscheidest. Sag, wann und wo dein Treffen stattfindet. Wähle,
            wieviele Personen mindestens teilnehmen müssen – und wieviele
            höchstens können. Kostet dein Angebot etwas? Falls ja, wähle
            zwischen einer Kollekte oder einem Fixpreis, den die Teilnehmer im
            Vornherein per App bezahlen. Fertig!
          </Text>
          <Button
            plain
            color={BERRY}
            text={'Treffen anbieten'}
            action={() => history.push('/register')}
          />
        </View>
        <View style={styles.step}>
          <H2>2. Teilnehmen</H2>
          <Text>
            Leute treffen und gemeinsam etwas unternehmen war noch nie so
            einfach. Entdecke Treffen in deiner Nähe und melde dich mit einem
            Klick an. Sofort bist du in einem Gruppenchat mit den anderen
            Teilnehmer und kannst dich mit ihnen absprechen. Um die Bezahlung
            musst du dich nicht kümmern – das geschieht automatisch per App. Und
            falls dir etwas dazwischen kommt, kannst du deine Teilnahme in
            Sekundenschnelle absagen.
          </Text>
          <Button
            plain
            color={BERRY}
            text={'Treffen finden'}
            action={() => history.push('/discover')}
          />
        </View>
        <View style={styles.step}>
          <H2>3. Treffen</H2>
          <Text>
            Jetzt wird's spannend: Du triffst dich mit den anderen Teilnehmern
            und erlebst etwas. Fotos und Videos kannst du nach dem Treffen
            direkt im gemeinsamen Chat teilen. Falls du Gastgeber warst, werden
            deine Einnahmen direkt deinem Guthaben gutgeschrieben. Und am besten
            planst du gleich dein nächstes Treffen. Viel Spass!
          </Text>
          <Button
            plain
            color={BERRY}
            text={'Konto erstellen'}
            action={() => history.push('/register')}
          />
        </View>
      </View>
    </StaticPage>
  );
}

export default HowItWorks;
